import React from "react";
import TableRow from "../../../marks/components/molecules/TableRow";

const MarksTable = ({ requests }) => {
  return (
    <div className="overflow-x-auto bg-white rounded shadow-md">
      <table className="min-w-full table-auto">
        <thead className="text-left bg-gray-100">
          <tr>
            {[
              "Candidate ID",
              "Full Name",
              "Email",
              "Gender",
              "Previous Job Position",
              "Mark/100",
              "Status",
            ].map((h, i) => (
              <th key={i} className="p-4 text-sm font-semibold text-gray-700">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(requests) && requests > 0 ? (
            requests.map((row, i) => <TableRow key={i} requests={row} />)
          ) : (
            <tr>
              <td colSpan={8} className="p-4 text-center text-gray-500">
                No Marks list available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default MarksTable;
